import React, { useState, useEffect } from 'react'
import { PaginationControl } from "react-bootstrap-pagination-control";
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { Link } from 'react-router-dom'
import { Get, Delete } from '../web_api/api'
import '../branch/branch.css'

export default function CmsTreatmentList() {
    const [dataCount, setDataCount] = useState("");
    const [page, setPage] = useState(1)
    const [list, setList] = useState([])
    const [rowsPerPage] = React.useState(10);

    const paginationItems = React.useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        return list.slice(start, end);
    }, [page, list]);

    const handleDelete = async (id) => {
        await Delete('/cms-treatment-type/', id)
        setList(prev => prev.filter(item => item._id !== id))
    }

    useEffect(() => {
        const fetch = async () => {
            const res = await Get('cms-treatment-types')
            setList(res.data)
            setDataCount(res.data.length)
        }
        fetch()
    }, [])

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <span className='current'>Treatment Type List</span>
            </div>

            <div className='branch-card'>
                <div className='branch-card-header'>
                    <span />
                    <Link to='/cms-treatment-create' className='branch-btn branch-btn-primary'>
                        + Add
                    </Link>
                </div>

                <div className='branch-card-body' style={{ padding: 0 }}>
                    <div className='branch-table-wrapper'>
                        <table className='branch-table'>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginationItems.map((item, i) => (
                                    <tr key={item._id}>
                                        <td>{(page - 1) * rowsPerPage + i + 1}</td>
                                        <td>{item.image && <img src={item.image} style={{ width: 100, height: 60, objectFit: 'cover' }} />}</td>
                                        <td>{item.name}</td>
                                        <td>{item.description}</td>
                                        <td>
                                            <IconButton aria-label='delete' onClick={() => handleDelete(item._id)}>
                                                <DeleteIcon className='text-danger' />
                                            </IconButton>
                                            <Link to={'/cms-treatment-update/' + item._id}>
                                                <IconButton aria-label='edit'>
                                                    <EditIcon className='text-warning' />
                                                </IconButton>
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 0' }}>
                    <PaginationControl
                        page={page}
                        between={4}
                        total={dataCount}
                        limit={10}
                        changePage={(page) => { setPage(page); }}
                        ellipsis={1}
                    />
                </div>
            </div>
        </div>
    )
}
